export const dataStates = {
  loaded: 0,
  loading: 1,
  notSet: 3,
  error: -1,
};

export class DataSetStatus {
  constructor() {
    this.status = dataStates.notSet;
    this.dataPromise = null;
  }
}
